import React from 'react'
import { Route } from 'react-router'
const Reporting = React.lazy(() => import('@/modules/reporting/components/reporting'))

const reportingRoutes = (
  <>
    <Route path='reporting' Component={Reporting} />
  </>
)

export default reportingRoutes
